import { PRICE_CURRENCY_OPTIONS } from "@constants";

import { formatPrice } from "./formatPrice";

import type { IPrice } from "@components/formControl/priceInput/types";
import type { ITime } from "@components/formControl/timeInput/types";
import type { IOption } from "@interfaces";

export const getPriceInitialValue = (
  price?: string | number,
  currency?: IOption,
): IPrice => {
  return {
    key: currency?.key || PRICE_CURRENCY_OPTIONS?.[0]?.key || "",
    value: currency?.value || PRICE_CURRENCY_OPTIONS?.[0]?.value || "",
    flag: currency?.flag || PRICE_CURRENCY_OPTIONS?.[0]?.flag,
    price: price?.toString() || "",
  };
};

export const getFormattedPrice = (
  _price: string | number | undefined,
  currency?: string,
): string => {
  const price = formatPrice(Number(_price || 0));

  return `${price || "0"} ${currency || PRICE_CURRENCY_OPTIONS?.[0]?.value || ""}`;
};

export const getTimeInitialValue = (
  time?: string | number,
  type?: IOption,
): ITime => {
  return {
    key: type?.key || "1",
    value: type?.value || "ثانیه",
    time: time?.toString() || "",
  };
};

export const EmptyTime: ITime = {
  key: "1",
  time: "",
  value: "ثانیه",
  icon: "TimeLine",
};
